<template>
  <div>
    <SubMenuHeader
      :title="$t('burgerMenu.about')"
      @onGoBack="onGoBack"
      @showVideo="$emit('showVideo')"
    />
    <AboutDetails/>
  </div>
</template>

<script>
import SubMenuHeader from '../../SubMenuHeader';
import AboutDetails from "@/components/hamburgerMenu/components/AboutDetails.vue";

export default {
  'name': 'about',
  'components': { AboutDetails, SubMenuHeader },
  'methods': {
    onGoBack() {
      this.$router.back();
    }
  }
}
</script>

<style scoped>

</style>
